import { render } from "./PatternDot.vue?vue&type=template&id=29f0c788"
import script from "./PatternDot.vue?vue&type=script&lang=js"
export * from "./PatternDot.vue?vue&type=script&lang=js"
script.render = render

export default script